import { connect } from 'react-redux';
import CurrenciesManagementEditPage from './CurrenciesManagementEditPage';
import { updateAsync } from './actions';

const mapDispatchToProps = dispatch => {
  return {
    onSubmit: model => dispatch(updateAsync(model)),
  };
};

const mergeProps = (propsFromState, propsFromDispatch, ownProps) => {
  return {
    onSubmit: model =>
      propsFromDispatch.onSubmit({
        ...model,
        id: ownProps.match.params.id,
      }),
    ...ownProps,
  };
};

const CurrenciesManagementEditPageContainer = connect(
  undefined,
  mapDispatchToProps,
  mergeProps,
)(CurrenciesManagementEditPage);

export default CurrenciesManagementEditPageContainer;
